import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import styled from 'styled-components';

const SuccessContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, ${props => props.theme.colors.background.accent} 0%, ${props => props.theme.colors.background.primary} 100%);
  padding: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SuccessContent = styled.div`
  text-align: center;
  max-width: 600px;
  padding: 2rem;
  background: #11162b;
  border-radius: 16px;
  box-shadow: 0 0 30px rgba(57, 255, 20, 0.4);
  border: 1px solid rgba(57, 255, 20, 0.3);
`;

const SuccessTitle = styled.h1`
  font-size: ${props => props.theme.typography.fontSize.xxl};
  color: #00ccff;
  margin-bottom: 1rem;
  text-shadow: 0 0 10px rgba(0, 204, 255, 0.8);
`;

const SuccessText = styled.p`
  font-size: ${props => props.theme.typography.fontSize.lg};
  color: #b0eaff;
  margin-bottom: 2rem;
`;

const SuccessIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 2rem;
`;

const HomeButton = styled(Link)`
  background: linear-gradient(135deg, #39ff14, #00ccff);
  color: #0a0f1c;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  display: inline-block;
  transition: all 0.3s ease;
  text-shadow: none;
  box-shadow: 0 0 20px rgba(57, 255, 20, 0.45);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 30px rgba(57, 255, 20, 0.6), 0 0 60px rgba(57, 255, 20, 0.3);
  }
`;

export default function Success() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <SuccessContainer>
      <SuccessContent>
        <SuccessIcon>🎉</SuccessIcon>
        <SuccessTitle>Payment Successful!</SuccessTitle>
        <SuccessText>
          Thank you for your booking! Your payment has been processed successfully.
          {sessionId && (
            <>
              <br />
              <strong>Booking Reference: {sessionId}</strong>
            </>
          )}
          <br /><br />
          You will receive a confirmation email shortly with all the details.
          Our team will contact you to confirm your rental and delivery arrangements.
        </SuccessText>
        <HomeButton to="/">
          Return to Home
        </HomeButton>
      </SuccessContent>
    </SuccessContainer>
  );
}
